// External dependencies
import React from 'react';
import { getAdminUserHref } from '../utils/member-url';
import { getCurrentUser } from '../../../core/client/services/client-runtime';

interface UserSummary {
  _id?: string;
  displayName?: string;
  username?: string;
}

export default function UserLink({
  user,
  publicProfile = false,
}: {
  user?: UserSummary | null;
  publicProfile?: boolean;
}) {
  if (!user || !user._id) {
    return <em>Unknown</em>;
  }

  const { _id, displayName, username } = user;
  const label =
    username && displayName
      ? `${username} (${displayName})`
      : username || displayName || 'Unknown member';
  if (publicProfile) {
    return username ? (
      <a href={`/profile/${username}`}>{label}</a>
    ) : (
      <span>{label}</span>
    );
  }
  const roles = getCurrentUser()?.roles || [];
  if (roles.includes('support-team') && !roles.includes('admin')) {
    return username ? (
      <a href={`/admin/support/member/${encodeURIComponent(username)}`}>
        {label}
      </a>
    ) : (
      <a href={`/admin/support/member/${encodeURIComponent(_id)}`}>{label}</a>
    );
  }
  return <a href={getAdminUserHref({ _id, username })}>{label}</a>;
}
